/* eslint-disable */ 
import {ScrollView, StyleSheet, View, Text, Image, ImageBackground, Pressable} from 'react-native';
import ScreenWrapper from '../../components/ScreenWrapper';
import InputWrapper from '../../components/InputWrapper';
import PrimaryButton from '../../components/PrimaryButton';
import {colors, radii, shadows, spacing, typography} from '../../config/theme';
import dummyMap from '../../assets/dummyMap.png';
import pumpLogo from '../../assets/pumpLogo.png';
import ReceiptIcon from '../../assets/icons/recipt.svg';
import { useState } from 'react';
import {useTranslation} from 'react-i18next';

const openStatus={
  open:{
    backgroundColor: colors.primaryFixed,
    textColor: colors.primary,
  },
  closed:{
    backgroundColor: colors.errorContainer,
    textColor: colors.onErrorContainer,
  }
}

const UploadReceipt = ({navigation}) => {
  const {t} = useTranslation();
  const [status, setStatus] = useState('open');
  return (
    <ScreenWrapper isBackButton={true} onBack={() => navigation.goBack()} Heading={t('root.UploadReceipt.title')}>
        <ImageBackground source={dummyMap} style={styles.imageBackground} imageStyle={styles.bgImage}>
          <ScrollView style={styles.scrollView} contentContainerStyle={styles.contentContainer}>
            <View style={styles.modalView}>
              <View style={styles.sheetHandle} />
              <View style={styles.modalBody}>
                <View style={styles.pumpDetails}>
                  <View style={styles.pumpLogoContainer}>
                    <Image source={pumpLogo} style={styles.pumpLogo} />
                  </View>
                  <View style={styles.pumpDetailsContainer}>
                    <View style={styles.nameDistance}>
                    <Text style={styles.pumpDetailsText} numberOfLines={1}>Shell Gas Station</Text>
                    <Text style={styles.distanceText}>(4.5 km)</Text>
                    </View>
                    <Text style={styles.addressText}>ANTWERPEN NOO SHELL EXPRESS. NOORDERLAAN 502, 2030 ANTWERPEN</Text>
                    <Text style={styles.priceText}>€0.95/ltr, updated 3 hrs back </Text>
                    <View style={[styles.statusBadge, {backgroundColor: openStatus[status].backgroundColor}]}>
                      <View style={[styles.statusDot, {backgroundColor: status === 'open' ? colors.secondary : colors.error}]} />
                      <Text style={[styles.statusText, {color: openStatus[status].textColor}]}>{status === 'open' ? t('root.PumpSearch.Open') : t('root.PumpSearch.Closed')}</Text>
                    </View>
                  </View>
                </View>
                <InputWrapper
                  placeholder={t('root.UploadReceipt.EnterPrice')}
                  style={styles.receiptInput}
                />
                <Pressable
                  accessibilityRole="button"
                  style={({pressed}) => [styles.receiptDocContainer, pressed && styles.receiptDocPressed]}>
                  <View style={styles.receiptIconCircle}>
                    <ReceiptIcon width={22} height={22} fill={colors.primary} />
                  </View>
                  <Text style={styles.plusText}>{t('root.UploadReceipt.ScanAndUploadReceipt')}</Text>
                </Pressable>
              </View>
              <PrimaryButton
                title={t('root.UploadReceipt.Save')}
                style={styles.uploadButton}
              />
            </View>
          </ScrollView>
        </ImageBackground>
      
    </ScreenWrapper>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    flexDirection: 'column',
  },
  contentContainer: {
    flexGrow: 1,
    justifyContent: 'flex-end',
  },
  imageBackground: {
    flex: 1,
    flexDirection: 'column',
  },
  bgImage: {
    resizeMode: 'cover',
  },
  modalView: {
    width: '100%',
    height:'60%',
    borderTopLeftRadius: radii.sheet,
    borderTopRightRadius: radii.sheet,
    alignSelf:'flex-end',
    backgroundColor: colors.surface,
    flexDirection: 'column',
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.sm,
    paddingBottom: 90,
    ...shadows.level2,
  },
  sheetHandle: {
    alignSelf: 'center',
    width: 40,
    height: 4,
    borderRadius: radii.pill,
    backgroundColor: colors.border,
    marginBottom: spacing.lg,
  },
  modalBody: {
    flexGrow: 1,
    flexDirection: 'column',
  },
  pumpDetails: {
    flexDirection: 'row',
    gap: spacing.md,
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: colors.borderSubtle,
    paddingBottom: spacing.lg,
  },
  pumpLogoContainer: {
    width: 64,
    height: 64,
    borderRadius: radii.card,
    backgroundColor: colors.surfaceMuted,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  pumpLogo: {
    width: 48,
    height: 48,
    resizeMode: 'contain',
  },
  pumpDetailsText:{
    ...typography.headlineSm,
    color: colors.text,
    flexShrink: 1,
  },
  pumpDetailsContainer:{
    flex: 1,
    flexDirection:'column',
    gap: spacing.xs,
  },
  nameDistance:{
    flexDirection:'row',
    justifyContent:'space-between',
    alignItems: 'center',
    gap: spacing.sm,
  },
  distanceText: {
    ...typography.labelMd,
    color: colors.textMuted,
  },
  addressText: {
    ...typography.bodySm,
    color: colors.textMuted,
  },
  priceText: {
    ...typography.labelLg,
    color: colors.primary,
  },
  statusBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: spacing.xs,
    paddingHorizontal: spacing.sm,
    paddingVertical: 2,
    borderRadius: radii.badge,
  },
  statusDot: {
    width: 6,
    height: 6,
    borderRadius: radii.pill,
  },
  statusText: {
    ...typography.labelSm,
  },
  receiptInput:{
    marginTop: spacing.lg,
    marginBottom: 0,
  },
  receiptDocContainer:{
    alignItems:'center',
    justifyContent: 'center',
    gap: spacing.sm,
    marginTop: spacing.md,
    paddingVertical: spacing.lg,
    paddingHorizontal: spacing.lg,
    borderWidth: 1.5,
    borderStyle: 'dashed',
    borderColor: colors.secondary,
    borderRadius: radii.card,
    backgroundColor: colors.mintTint,
  },
  receiptDocPressed: {
    backgroundColor: colors.mintSoft,
  },
  receiptIconCircle: {
    width: 44,
    height: 44,
    borderRadius: radii.pill,
    backgroundColor: colors.mintSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  plusText:{
    ...typography.labelLg,
    color: colors.primary,
    textAlign: 'center',
  },
  uploadButton:{
    marginTop: spacing.lg,
    alignSelf:'flex-end'
  },
});

export default UploadReceipt;
